export default class CollectionPointForm {
    name
    areaCode
    addressZipCode
    addressName
    number
    detail
    addressNeighborhoodName
    addressNeighborhoodCityName
    addressNeighborhoodCityStateName
    latitude
    longitude
}
